import { mastraClient } from '@/lib/mastra-client';

export async function fetchTools() {
  return mastraClient.listTools();
}
